import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)

// 不用手动引入 `import app from './modules/app'`
// 可以自动引入 ./modules/目录下的所有js
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

export default new Vuex.Store({
    //引入modules/目录下所有js 模块
    modules,
    // 这里设置的是通用方法,不用再每个模块js写mutations了
    // this.$store.commit("set", ["user.info", { id:'1000',name: 'admin' }]);
    mutations: {
        //设置值
        set(state, val) {
            // 如果是多级
            var index = val[0].lastIndexOf(".");
            if (index != -1) {
                var obj = eval("state." + val[0].substring(0, index));
                obj[val[0].substring(index + 1)] = val[1]
            } else {
                state[val[0]] = val[1]
            }
        },
        //设置值 同时保存
        save(state, val) {
            this.commit("set", val);
            Cookies.set(val[0], val[1]);
        },
        // 向数组添加数据
        push(state, val) {
            var obj = eval("state." + val[0]);
            obj.push(val[1]);
        },
        // 数组删除数据
        splice(state, val) {
            var obj = eval("state." + val[0]);
            if (val.length <= 3) {
                obj.splice(val[1], val[2] || 1);
            } else {
                obj.splice(val[1], val[2], val[3]);
            }
        }
    }
})